export enum Actions {
  MORE_ACTIONS = 'more-actions',
  DELETE_CONFIRMATION = 'delete-confirmation',
  REMOVE_SCAN = 'remove-scan',
  SELECT_NEW_SCAN = 'select-new-scan',
}
